export default __webpack_public_path__ + "static/media/lorcana_legendary.bd7b51d5.svg";